import React from 'react';
import { Link } from 'react-router-dom';

const SectionHeading = ({ children }) => (
  <h2 style={{ fontSize: 20, marginBottom: 12 }}>{children}</h2>
);

const SubHeading = ({ children }) => (
  <h3 style={{ fontSize: 16, marginBottom: 8, marginTop: 16 }}>{children}</h3>
);

function Terms() {
  return (
    <div className="container pnp-legal" style={{ maxWidth: 800, paddingTop: 40, paddingBottom: 60 }}>
      <Link to="/" style={{ color: 'var(--primary)', fontSize: 14 }}>
        &larr; Back to Home
      </Link>

      <h1 style={{ marginTop: 24, marginBottom: 8 }}>Terms of Service</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 32 }}>
        Last updated: April 27, 2026
      </p>

      <div style={{ lineHeight: 1.7, color: 'var(--text)' }}>
        <section style={{
          marginBottom: 32,
          padding: 16,
          background: 'rgba(239,68,68,0.05)',
          border: '1px solid rgba(239,68,68,0.25)',
          borderRadius: 12,
        }}>
          <p style={{ margin: 0, fontWeight: 600, fontSize: 14 }}>
            PLEASE READ CAREFULLY. These Terms include a binding arbitration clause and class-action
            waiver (Section 16), broad disclaimers of warranty (Section 12), a strict limitation of
            liability (Section 13), and a release and assumption of risk (Section 14). By creating
            an account or using the Service, you agree to these Terms.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>1. Acceptance of Terms</SectionHeading>
          <p>
            These Terms of Service (the &ldquo;Terms&rdquo;) form a legally binding agreement between you
            (&ldquo;you,&rdquo; &ldquo;your&rdquo;) and Pick &lsquo;N Pray, operated by [OPERATOR] (the
            &ldquo;Operator,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;), governing your access to and use
            of Pick &lsquo;N Pray, including the website, mobile applications, APIs, and any related
            features (collectively, the &ldquo;Service&rdquo;). By accessing, creating an account on, or
            otherwise using the Service, you represent that you have read, understood, and agree to
            be bound by these Terms and our Privacy Policy. If you do not agree, do not use the
            Service.
          </p>
          <p>
            We may modify these Terms at any time by posting the revised version with a new
            &ldquo;Last updated&rdquo; date. Material changes will be reasonably highlighted in-app or by
            email. Your continued use of the Service after a change constitutes acceptance of the
            revised Terms.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>2. The Service</SectionHeading>
          <p>
            Pick &lsquo;N Pray is a social prediction platform for mixed martial arts (MMA) events.
            Features include, but are not limited to:
          </p>
          <ul style={{ marginLeft: 24, marginBottom: 12 }}>
            <li>Creating, joining, and managing private prediction pools (&ldquo;Pools&rdquo;);</li>
            <li>Submitting fight-by-fight predictions (&ldquo;Picks&rdquo;);</li>
            <li>Viewing leaderboards, scores, badges, and historical performance;</li>
            <li>
              Chatting with other members of a Pool through &ldquo;Corner Chat,&rdquo; where messages
              are auto-deleted after thirty (30) days;
            </li>
            <li>Optional public &ldquo;Title Shot&rdquo; pools that any registered user may enter for free.</li>
          </ul>
          <p>
            We may add, modify, suspend, or remove features at any time without notice or liability.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>3. Eligibility</SectionHeading>
          <p>
            You must be at least eighteen (18) years old (or the age of majority in your
            jurisdiction, whichever is greater) to use the Service. By using the Service, you
            represent and warrant that you meet this requirement and that your use of the Service
            does not violate any applicable law.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>4. Entertainment Only &mdash; No Gambling, No Money on the Platform</SectionHeading>
          <p style={{ fontWeight: 600, marginBottom: 12 }}>
            THE SERVICE IS PROVIDED STRICTLY FOR ENTERTAINMENT PURPOSES.
          </p>
          <p>
            We do not collect, hold, transfer, escrow, or distribute any money, prizes, entry fees,
            payouts, or anything of monetary value. We do not facilitate or operate any form of
            gambling, sports wagering, fantasy contest with cash prizes, or skill-based contest with
            cash prizes. Any monetary arrangement between Pool members &mdash; including entry fees,
            payouts, or side bets &mdash; takes place entirely outside the Service and is the sole
            responsibility of the participants involved. We provide no escrow, no guarantees, and no
            mediation. We are not your agent, fiduciary, or financial intermediary in any way.
          </p>
          <p>
            You are solely responsible for determining whether your participation in any Pool, and
            any associated monetary arrangement, is lawful in your jurisdiction. Use of the Service
            where prohibited by law is itself prohibited.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>5. Accounts and Security</SectionHeading>
          <p>
            You are responsible for: (a) maintaining the confidentiality of your credentials,
            (b) all activity that occurs under your account, and (c) the accuracy of any
            information you submit. You agree to notify us immediately of any unauthorized use of
            your account. We are not liable for any loss or damage arising from your failure to
            keep your credentials secure.
          </p>
          <p>
            You may delete your account at any time from the in-app Settings page. Deletion scrubs
            your personally identifying information, anonymizes your historical record (so other
            members&apos; Pool history is preserved), deletes your Corner Chat messages, and prevents
            future login. See our Privacy Policy for details.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>6. User Content</SectionHeading>
          <p>
            &ldquo;User Content&rdquo; means anything you submit to the Service, including Picks, Pool
            names, profile information, and Corner Chat messages. You retain ownership of your
            User Content. You grant us a worldwide, non-exclusive, royalty-free, sublicensable
            license to host, store, reproduce, modify (for formatting only), display, and
            distribute your User Content solely as needed to operate, provide, and improve the
            Service.
          </p>
          <p>
            You represent and warrant that your User Content does not violate any law or
            third-party right. You are solely responsible for your User Content and for any
            consequences of submitting it.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>7. Acceptable Use</SectionHeading>
          <p style={{ marginBottom: 12 }}>You agree not to, and not to attempt to:</p>
          <ul style={{ marginLeft: 24, marginBottom: 12 }}>
            <li>Use the Service to harass, threaten, defame, or abuse any person;</li>
            <li>Post or transmit content that is obscene, hateful, sexually explicit, or otherwise objectionable;</li>
            <li>Impersonate any person or misrepresent your affiliation;</li>
            <li>Submit malware, viruses, or other harmful code;</li>
            <li>Probe, scan, or test the vulnerability of the Service or circumvent security or rate-limiting features;</li>
            <li>Use automated means (bots, scrapers, crawlers) to access the Service without our written permission;</li>
            <li>Interfere with or disrupt the Service or its underlying infrastructure;</li>
            <li>Use the Service for any commercial purpose without our written permission;</li>
            <li>Use the Service in any way that violates any applicable law or these Terms.</li>
          </ul>
          <p>
            We reserve the right, but not the obligation, to remove any User Content and to suspend
            or terminate any account that violates these rules.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>8. Pool Commissioners and Member Transactions</SectionHeading>
          <p>
            A &ldquo;Commissioner&rdquo; is the user who created a Pool. Commissioners are solely
            responsible for managing their Pool, including: collecting and distributing any funds
            that members agree to exchange among themselves, resolving disputes, enforcing their
            Pool&apos;s rules, and complying with all applicable law. We are not a party to any
            arrangement between Commissioners and members. We do not verify, endorse, guarantee,
            facilitate, or hold any payments. Any dispute concerning entry fees, payouts, or any
            other monetary or non-monetary arrangement is solely between the Pool members involved.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>9. No Affiliation with UFC or Any Sports Organization</SectionHeading>
          <p>
            Pick &lsquo;N Pray is not affiliated with, endorsed by, sponsored by, or otherwise
            connected to the Ultimate Fighting Championship (UFC), Zuffa LLC, TKO Group Holdings,
            any MMA promotion, any fighter, any sportsbook, or any third-party data provider. All
            trademarks, names, logos, and likenesses are the property of their respective owners
            and are referenced for identification purposes only.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>10. Third-Party Services</SectionHeading>
          <p>
            The Service relies on third-party providers including, without limitation, Supabase
            (database and realtime), Render (server hosting), Vercel (web hosting and analytics),
            Apple App Store, and Google Play Store. We do not control these providers and are not
            responsible for any act or omission by them.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>11. Privacy</SectionHeading>
          <p>
            Our collection and use of personal information is described in our{' '}
            <Link to="/privacy" style={{ color: 'var(--primary)' }}>Privacy Policy</Link>, which is
            incorporated into these Terms by reference. By using the Service, you consent to our
            data practices as described there.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>12. Disclaimer of Warranties</SectionHeading>
          <p style={{ fontWeight: 600, marginBottom: 12 }}>
            THE SERVICE IS PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE,&rdquo; WITH ALL FAULTS, AND
            WITHOUT WARRANTY OF ANY KIND, EXPRESS, IMPLIED, OR STATUTORY. TO THE MAXIMUM EXTENT
            PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, INCLUDING WITHOUT LIMITATION ANY IMPLIED
            WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, TITLE,
            QUIET ENJOYMENT, ACCURACY, AND ANY WARRANTY ARISING OUT OF COURSE OF DEALING, USAGE, OR
            TRADE.
          </p>
          <p>
            Without limiting the foregoing, we do not warrant that: (a) the Service will meet your
            requirements; (b) the Service will be uninterrupted, timely, secure, or error-free;
            (c) any data, including fight results, scores, leaderboards, and Pool standings, will
            be accurate, complete, or current; or (d) any errors will be corrected. Fight
            information and results are aggregated from third-party sources and may contain
            inaccuracies or be delayed. You rely on the Service at your own risk.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>13. Limitation of Liability</SectionHeading>
          <p style={{ fontWeight: 600, marginBottom: 12 }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE OPERATOR, ITS OWNERS,
            OFFICERS, EMPLOYEES, CONTRACTORS, AGENTS, AFFILIATES, OR LICENSORS (COLLECTIVELY, THE
            &ldquo;OPERATOR PARTIES&rdquo;) BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA,
            USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR RELATING TO THESE TERMS OR
            THE SERVICE, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT, STRICT LIABILITY,
            STATUTE, OR OTHERWISE) AND EVEN IF AN OPERATOR PARTY HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p style={{ fontWeight: 600, marginBottom: 12 }}>
            IN NO EVENT WILL THE OPERATOR PARTIES&apos; TOTAL AGGREGATE LIABILITY ARISING OUT OF OR
            RELATING TO THESE TERMS OR THE SERVICE EXCEED THE GREATER OF (A) ONE HUNDRED U.S.
            DOLLARS (US$100.00) OR (B) THE AMOUNTS YOU HAVE PAID TO US IN THE TWELVE (12) MONTHS
            PRECEDING THE CLAIM (WHICH, FOR THE AVOIDANCE OF DOUBT, IS ZERO IF YOU HAVE PAID US
            NOTHING).
          </p>
          <p>
            Some jurisdictions do not allow the exclusion or limitation of certain damages. To the
            extent any limitation in this Section is unenforceable as to you, the limitation will
            apply to the maximum extent permitted by law and the remainder of this Section will
            remain in effect.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>14. Assumption of Risk and Release</SectionHeading>
          <p>
            You acknowledge and agree that you use the Service at your own risk. You assume all
            risk arising from: (a) your use of the Service and reliance on any data, scores, or
            results; (b) any monetary or non-monetary arrangement you enter into with another user;
            (c) the conduct of other users, including in Corner Chat; and (d) any failure,
            interruption, error, inaccuracy, or unavailability of the Service.
          </p>
          <p style={{ fontWeight: 600, marginTop: 12 }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU FOREVER RELEASE, WAIVE, AND DISCHARGE THE
            OPERATOR PARTIES FROM ANY AND ALL CLAIMS, DEMANDS, ACTIONS, CAUSES OF ACTION, COSTS,
            EXPENSES, AND DAMAGES OF EVERY KIND, KNOWN OR UNKNOWN, ARISING OUT OF OR RELATING IN
            ANY WAY TO YOUR USE OF THE SERVICE, INCLUDING ANY DISPUTE BETWEEN YOU AND ANY OTHER
            USER.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>15. Indemnification</SectionHeading>
          <p>
            You agree to indemnify, defend, and hold harmless the Operator Parties from and
            against any and all claims, liabilities, damages, losses, and expenses (including
            reasonable attorneys&apos; fees and costs) arising out of or relating to: (a) your use of
            the Service; (b) your User Content; (c) your violation of these Terms or any law; or
            (d) your dispute with any other user or third party.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>16. Binding Arbitration; Class-Action Waiver</SectionHeading>
          <p>
            Any dispute, claim, or controversy arising out of or relating to these Terms or the
            Service (a &ldquo;Dispute&rdquo;) will be resolved exclusively by final and binding
            individual arbitration administered by the American Arbitration Association
            (&ldquo;AAA&rdquo;) under its Consumer Arbitration Rules then in effect, except that
            either party may bring an individual action in a small-claims court of competent
            jurisdiction.
          </p>
          <p>
            The arbitration will be conducted in Tennessee, in English, by a single arbitrator. The
            arbitrator&apos;s decision will be final and binding. Judgment on the award may be entered
            in any court of competent jurisdiction.
          </p>
          <p style={{ fontWeight: 600 }}>
            YOU AND THE OPERATOR EACH AGREE THAT DISPUTES WILL BE RESOLVED ONLY ON AN INDIVIDUAL
            BASIS AND NOT IN ANY CLASS, COLLECTIVE, OR REPRESENTATIVE ACTION. THE ARBITRATOR HAS NO
            AUTHORITY TO CONDUCT A CLASS, COLLECTIVE, OR REPRESENTATIVE PROCEEDING. YOU WAIVE ANY
            RIGHT TO A JURY TRIAL.
          </p>
          <p>
            If any provision of this Section is found to be unenforceable, the remainder of this
            Section will remain in effect to the fullest extent permitted by law.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>17. Governing Law and Venue</SectionHeading>
          <p>
            These Terms are governed by the laws of the State of Tennessee, U.S.A., without regard
            to its conflict-of-laws principles. Subject to Section 16, you and we consent to the
            exclusive jurisdiction and venue of the state and federal courts located in Tennessee
            for any matter not subject to arbitration.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>18. Apple App Store Additional Terms</SectionHeading>
          <p>
            If you access the Service through an application downloaded from the Apple App Store
            (the &ldquo;App&rdquo;), the following additional terms apply, and to the extent of any
            conflict, the following terms control:
          </p>
          <ul style={{ marginLeft: 24, marginBottom: 12 }}>
            <li>
              These Terms are between you and the Operator only, not Apple Inc. (&ldquo;Apple&rdquo;).
              Apple is not responsible for the App or its content.
            </li>
            <li>
              Apple has no obligation to provide any maintenance or support services for the App.
            </li>
            <li>
              In the event of any failure of the App to conform to any applicable warranty, you may
              notify Apple, and Apple will refund the App&apos;s purchase price (if any) to you. To the
              maximum extent permitted by law, Apple has no other warranty obligation whatsoever
              with respect to the App.
            </li>
            <li>
              Apple is not responsible for addressing any claims relating to the App or your
              possession or use of the App, including product liability claims, claims that the App
              fails to conform to any applicable legal or regulatory requirement, or claims arising
              under consumer protection or similar legislation.
            </li>
            <li>
              In the event of any third-party claim that the App or your use of the App infringes
              that third party&apos;s intellectual property rights, the Operator (not Apple) is solely
              responsible for the investigation, defense, settlement, and discharge of that claim.
            </li>
            <li>
              You represent and warrant that you are not located in a country that is subject to a
              U.S. Government embargo or designated by the U.S. Government as a &ldquo;terrorist
              supporting&rdquo; country, and that you are not listed on any U.S. Government list of
              prohibited or restricted parties.
            </li>
            <li>
              Apple and its subsidiaries are third-party beneficiaries of these Terms, and upon
              your acceptance, Apple has the right (and is deemed to have accepted the right) to
              enforce these Terms against you as a third-party beneficiary.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>19. Termination</SectionHeading>
          <p>
            We may suspend or terminate your access to the Service at any time, for any reason or
            no reason, with or without notice. Sections that by their nature should survive
            termination &mdash; including Sections 6 (User Content), 12 (Disclaimer), 13
            (Limitation of Liability), 14 (Release), 15 (Indemnification), 16 (Arbitration),
            17 (Governing Law), and 21 (Miscellaneous) &mdash; will survive any termination.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>20. Changes to the Service</SectionHeading>
          <p>
            We may add, change, suspend, or remove features at any time without notice. We may
            also stop offering the Service entirely. We are not liable to you or any third party
            for any modification, suspension, or discontinuation of the Service.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>21. Miscellaneous</SectionHeading>
          <SubHeading>Entire Agreement</SubHeading>
          <p>
            These Terms, together with our Privacy Policy, constitute the entire agreement between
            you and the Operator regarding the Service and supersede any prior agreements.
          </p>
          <SubHeading>Severability</SubHeading>
          <p>
            If any provision of these Terms is held unenforceable, that provision will be modified
            to the minimum extent necessary to make it enforceable, and the remaining provisions
            will remain in full force and effect.
          </p>
          <SubHeading>No Waiver</SubHeading>
          <p>
            Our failure to enforce any provision of these Terms is not a waiver of our right to do
            so later.
          </p>
          <SubHeading>Assignment</SubHeading>
          <p>
            You may not assign these Terms without our prior written consent. We may assign these
            Terms at any time without notice.
          </p>
          <SubHeading>Force Majeure</SubHeading>
          <p>
            We are not liable for any failure or delay caused by events outside our reasonable
            control, including natural disasters, network outages, third-party provider failures,
            and acts of government.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <SectionHeading>22. Contact</SectionHeading>
          <p>
            Questions about these Terms? Email{' '}
            <a href="mailto:kyle@picknpray.com" style={{ color: 'var(--primary)' }}>kyle@picknpray.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
